export enum ActionTypes{
  KomaClick = 1,
  MasuClick,
  PromSelect,
}



/** WEBPACK FOOTER **
 ** ./client/actiontypes.ts
 **/